import { type EnumProps, withEnumBadge } from "@/components/EnumBadge.tsx";
import { Trans } from "@lingui/react/macro";
import type { DiskStatusEnum } from "@warrenio/api-spec/spec.oats.gen";

const diskStatuses: Record<DiskStatusEnum, EnumProps> = {
    Active: {
        label: <Trans comment="Disk status">Active</Trans>,
        color: "success",
    },
    Reserved: {
        label: <Trans comment="Disk status">Reserved</Trans>,
        color: "error",
    },
};

export const DiskStatusBadge = withEnumBadge(diskStatuses);
